export default __webpack_public_path__ + "svg/calendar/2027/1/marzo.svg?4123cc51";